import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import Api from '@/services/http'
import { AppDispatch } from '@/store'
import { CourierState, ICourierProps } from './types'

const initialState: CourierState = {
  authCouriers: [],
  unAuthCouriers: [],
}

const commonSlice = createSlice({
  name: 'courier',
  initialState,
  reducers: {
    setCouriers(state, action: PayloadAction<Record<string, ICourierProps[]>>): CourierState {
      return {
        authCouriers: action.payload.authExpressTypes,
        unAuthCouriers: action.payload.unAuthExpressTypes,
      }
    },
  },
})

export const { setCouriers } = commonSlice.actions
export default commonSlice.reducer

export const fetchCourier = () => async (dispatch: AppDispatch) => {
  const response = await Api.admin.post('/api/express/new_guide_express')
  const { code, data, bizMessage, message } = response
  if (code === 'SUCCESS' && data && data.expressTypeVo) {
    dispatch(setCouriers(data.expressTypeVo))
    return Promise.resolve({ code, bizMessage, message })
  }
  return Promise.reject({ code, bizMessage, message })
}
